function O(props) {
	return props.children || [];
}
module.exports = { O: O };



//////////////////
// WEBPACK FOOTER
// ./node_modules/traks/o.js
// module id = 286
// module chunks = 28